<template>
  <div class="bundle-card">
    <div class="disabled" v-if="bundle.disabled">
      <Loading />
    </div>
    <div class="not-disabled" v-if="!bundle.disabled">
      <div
        class="banner inactive"
        v-if="bundle.status === 'inactive'"
      >{{ $t('Inactive Content') }}</div>
      <div
        class="banner deactivating-soon"
        v-if="bundle.deactivatesAt"
      >{{ $t("Deactivating on {deactivationDate}", { deactivationDate }) }}</div>
      <RatioContainer>
        <img
          class="image"
          :src="bundle.imageUrl"
          :alt="bundle.title"
          :style="{ background, paddingTop: (bundle.imageUrl) ? 0 : '5rem' }"
        />
      </RatioContainer>
      <div class="content">
        <h1>{{ bundle.title }}</h1>
        <div class="latest-update">{{ $t('Latest Update') }}: {{ lastUpdated }}</div>
        <!-- <div class="status" v-for="pendingCause in pendingCauses" :key="pendingCause">
          <svg>
            <use xlink:href="#icon-alert-triangle" />
          </svg>
          <span class="verification">{{ pendingCause }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import idToGradient from '@/core/shared/helpers/idToGradient';
// import BundleValidator from './BundleValidator';
import RatioContainer from '@/core/shared/components/utils/RatioContainer';
import Loading from '@/core/shared/components/Loading';

@Component({
  components: {
    Loading,
    RatioContainer,
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
  },
})
export default class BundleCard extends Vue {
  get background () {
    return idToGradient(this.bundle.id);
  }

  // get pendingCauses () {
  //   const result = new Set();

  //   const pendingDetailsMsg = this.$t('Pending Content Details');
  //   const pendingPricingInformationMsg = this.$t('Pending Pricing Information');
  //   const pendingPublishingMsg = this.$t('Pending Publishing');
  //   const pendingEULAMsg = this.$t('Pending EULA');

  //   switch (this.bundle.approvalStatus) {
  //   case 'rejected':
  //     result.add(cdsRejectedMsg);
  //     return result;
  //   case 'pending':
  //     result.add(cdsPendingApprovalMsg);
  //     break;
  //   }
  //   switch (this.bundle.status) {
  //   case 'keys':
  //     result.add(pendingSteamKeysMsg);
  //     return result;

  //   case 'content':
  //     result.add(pendingContentDetailsMsg);
  //     return result;

  //   case 'price':
  //     result.add(pendingPricingInformationMsg);
  //     return result;

  //   case 'eula':
  //     result.add(pendingPublishingMsg);
  //     return result;
  //   }
  //   if (
  //     !BundleValidator.detailsValidity(this.bundle) ||
  //     !BundleValidator.playerValidity(this.bundle)
  //   ) {
  //     if (!result.has(pendingContentDetailsMsg)) result.add(pendingContentDetailsMsg);
  //   } else if (
  //     !BundleValidator.priceValidity(this.bundle)
  //   ) {
  //     if (!result.has(pendingPricingInformationMsg)) result.add(pendingPricingInformationMsg);
  //   } else if (!BundleValidator.EULAValidity(this.bundle)) {
  //     if (!result.has(pendingEULAMsg)) result.add(pendingEULAMsg);
  //   } else if (!BundleValidator.keysValidity(this.bundle)) {
  //     if (!result.has(pendingSteamKeysMsg)) result.add(pendingSteamKeysMsg);
  //   }
  //   return result;
  // }

  get lastUpdated () {
    return moment(this.bundle.updatedAt).format('LLL');
  }

  // get deactivationDate () {
  //   return moment(this.bundle.deactivatesAt).format('MMM Do YYYY');
  // }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.bundle-card {
  @apply --panelDropShadow;

  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: var(--radius);
  background-color: var(--colorWhite);
  display: flex;
  flex-direction: column;

  & .disabled {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .banner {
    @apply --f6;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    color: var(--colorWhite);
    margin: 0;
    padding: var(--spacingXS);
    text-align: center;

    &.deactivating-soon {
      background: var(--colorErrorFlat);
    }

    &.inactive {
      background: var(--colorErrorFlat);
    }
  }

  & .image {
    @apply --f6;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: var(--radius) var(--radius) 0 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: var(--colorWhite);
    margin: 0;
    line-height: var(--spacingXL);
  }

  & .content {
    @apply --f5;

    padding: var(--spacingXS);
    flex: 1 0 auto;

    @media (--tablet) {
      padding: var(--spacingSm);
    }

    & h1 {
      @apply --f2;

      margin: 0;
    }

    & .latest-update {
      @apply --f7;

      margin-top: calc(var(--spacingXS) * 2);
    }

    & .status {
      @apply --f7;

      fill: var(--colorErrorFlat);
      color: var(--colorErrorFlat);
      display: flex;
      align-items: center;
      margin-top: calc(var(--spacingXS) * 2);

      & svg {
        width: 1.5rem;
        height: 1.5rem;
        position: relative;
        bottom: 0.1rem;
        margin-right: var(--spacingXS);
      }
    }
  }

  & .stats {
    display: flex;

    & .stat-block {
      @apply --f5;

      flex: 1 1 auto;
      text-align: center;
      padding: var(--spacingSm);

      border-right: 0.1rem solid var(--colorManatee);

      & h3 {
        @apply --f6;

        margin: 0;
      }

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
